import { render, staticRenderFns } from "./folder-item-view-5-settings-view.vue?vue&type=template&id=1f183d2b&"
import script from "./folder-item-view-5-settings-view.vue?vue&type=script&lang=ts&"
export * from "./folder-item-view-5-settings-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports